module.exports = __webpack_public_path__ + "img/01_body_1200mk5_nasty.1a5471b3.png";